export default __webpack_public_path__ + "static/media/closeIcon.a1bef516.svg";